<div class="PGHTMLEditor {{readonly ? 'PGHTMLEditor--ReadOnly' : ''}}">
    @if (readonly) {
        <div class="PGHTMLEditor-ReadonlyOverlay bg-secondary"></div>
    }
    <div [hidden]="showAdvanced">
        @if (isInitialized) {
            <editor [init]="editorParams" [initialValue]="value ?? ''"></editor>
        }
    </div>
    @if (showAdvanced) {
        <div>
            <textarea [readonly]="readonly" class="form-control PGHTMLEditor-Advanced" [(ngModel)]="value" (ngModelChange)="setEditorValue(); onValueChange();"></textarea>
        </div>
    }
    @if (!readonly && allowAdvanced) {
        <div class="PGControlsAdvanced text-end mt-1">
            <button type="button" class="btn btn-sm btn-{{ showAdvanced ? 'primary' : 'outline-primary' }}" (click)="showAdvanced = !showAdvanced"
                [attr.aria-pressed]="showAdvanced"
                [attr.aria-label]="'pg-html-editor.a11y.toggle-source' | locTranslate">
                <i class="fa-regular fa-code" aria-hidden="true"></i>
            </button>
        </div>
    }
</div>

<ng-template #modalSelectImage>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-html-editor.insert-image' | locTranslate }}</h5>
    </div>
    <div class="modal-body">
        <app-pg-file-picker fileType="images" [(ngModel)]="selectImageValue"></app-pg-file-picker>
        <div class="text-end mt-3">
            <button class="btn btn-secondary" (click)="selectImageDismiss()">{{ 'pg-html-editor.cancel' | locTranslate }}</button>
            <button class="btn btn-primary ms-1" [disabled]="selectImageValue == null || selectImageValue == ''" (click)="selectImageClose()">{{ 'pg-html-editor.ok' | locTranslate }}</button>
        </div>
    </div>
</ng-template>

